<div class="fixed-buttons" *ngIf="!list?.length">
  <app-common-add-button [buttonData]="{title:'Add-Zone',imageUrl:'../../../../assets/images/addIcon.svg'}"
      (buttonClick)="addZone()"></app-common-add-button>
</div>
<div class="zone-list-container">
  <div class="zone-list-wrap" #zoneList>
    <ul class="zone-list">
      <ng-container *ngIf="list?.length;">
        <ng-container *ngFor="let zone of list; last as isLastZone; index as zoneIndex; first as isSuperZone;"
          [ngTemplateOutlet]="zoneNode"
          [ngTemplateOutletContext]="{ $implicit: zone, isLast: isLastZone, index: zoneIndex, depth: depth, isSuperFirst: isSuperZone }">
        </ng-container>
      </ng-container>
    </ul>
  </div>
  <ng-template #zoneNode let-data let-last="isLast" let-index="index" let-depth="depth" let-parent="parentContent"
    let-super="isSuperFirst">
    <li [ngClass]="{'-open': true, 'depth-one': (depth === 0)}"
      id="zone-{{ data?._id }}" #zoneItem>
      <div class="zone-item -sticky" [ngClass]="{'has-floor-plan': data?.floorPlan && !more}" (click)="data?.floorPlan ? onNavigateToPlanClick($event, data) : null">
        <div class="header">
          <div class="category">
            <img class="icon" src="../../../../assets/images/icon-zone-{{ data?.nature?.toLowerCase() }}.svg"
              alt="{{ data?.nature | lowercase | translate }}" matTooltip="{{ data?.nature | lowercase | translate }}"
              [matTooltipPosition]="'above'" />
          </div>
          <h4 matTooltip="{{data?.name}}">{{ data?.name | truncate:13:'..' }}</h4>
          <div class="floor-plan" *ngIf="data?.floorPlan && !more">
            <img class="icon" src="../../../../assets/images/icon-zone-floorplan.svg" alt="edit"
              matTooltip="{{ MESSAGES?.ZONE_LIST_FLOOR_PLAN_TOOLTIP | replace:'[ZONE]': data?.name }}"
              [matTooltipPosition]="'above'" />
          </div>
          <div class="more-options" *ngIf="more">
            <img class="icon"
                 src="../../../../assets/images/general-more-black.svg"  
                 [matMenuTriggerFor]="moreMenu" 
                 (click)="$event.stopPropagation()"
                 alt="More options" 
                 matTooltip="More options"
                 [matTooltipPosition]="'above'" />
                 <mat-menu #moreMenu="matMenu">
                  <button mat-menu-item (click)="onMoreActionClick('add',data)" style="display: flex;" *ngIf="data?.depth<depthLimit">
                    <img class="icon" src="../../../../assets/images/general-add-without-circle-black.svg" alt="add" style="width: 17px;"/>
                    <span style="padding-left: 15px;color:#205B5E">Add</span>
                  </button>
                  <mat-divider *ngIf="(data?.depth<depthLimit)"></mat-divider>
                  <button mat-menu-item (click)="onMoreActionClick('edit',data)">
                    <img class="icon" src="../../../../assets/images/general-edit-black.svg" alt="edit" style="width: 17px;"/>
                    <span style="padding-left: 15px;color:#205B5E">Edit</span>
                  </button>
                  <mat-divider></mat-divider>
                  <button mat-menu-item (click)="onMoreActionClick('view',data)">
                    <img class="icon" src="../../../../assets/images/eye.svg" alt="view" style="width: 17px;"/>
                    <span style="padding-left: 15px;color:#205B5E">View</span>
                  </button>
                  <mat-divider></mat-divider>
                  <button mat-menu-item (click)="onMoreActionClick('delete',data)">
                    <img class="icon" src="../../../../assets/images/delete.svg" alt="delete" style="width: 17px;"/>
                    <span style="padding-left: 15px;color:#205B5E">Delete</span>
                  </button>
                </mat-menu>
          </div>
          <div class="toggle-tree" *ngIf="data?.children?.length">
            <img class="icon" src="../../../../assets/images/icon-tree.svg" (click)="onZoneClick($event, 'zone-' + data?._id, super)"
              alt="{{ MESSAGES?.ZONE_LIST_EXPAND_HOVER_LABEL }}"
              matTooltip="{{ MESSAGES?.ZONE_LIST_EXPAND_HOVER_LABEL }}" [matTooltipPosition]="'above'" />
          </div>
        </div>
        <div class="topic-list">
          <div class="topic" *ngIf="data?.childCount">
            <img class="icon" src="../../../../assets/images/icon-zone-{{ getChildCategory(data)?.toLowerCase() }}.svg"
              matTooltip="{{ MESSAGES?.ZONE_LIST_TOTAL_CHILD_ZONE_TOOLTIP | replace:'[ZONE]': (getChildCategory(data) | lowercase | translate) | replace:'[COUNT]': data?.childCount }}"
              [matTooltipPosition]="'above'" />
            <span class="count">{{ data?.childCount }}</span>
          </div>
          <div class="topic" *ngIf="data?.assetCount">
            <img class="icon" src="../../../../assets/images/icon-zone-assets.svg"
              matTooltip="{{ MESSAGES?.ZONE_LIST_TOTAL_ASSETS_TOOLTIP | replace:'[COUNT]': data?.assetCount }}"
              [matTooltipPosition]="'above'" />
            <span class="count">{{ data?.assetCount }}</span>
          </div>
          <div class="topic" *ngIf="data?.deviceCount">
            <img class="icon" src="../../../../assets/images/icon-zone-devices.svg"
              matTooltip="{{ MESSAGES?.ZONE_LIST_TOTAL_DEVICES_TOOLTIP | replace:'[COUNT]': data?.deviceCount }}"
              [matTooltipPosition]="'above'" />
            <span class="count">{{ data?.deviceCount }}</span>
          </div>
        </div>
      </div>
      <ng-container>
        <ul>
          <ng-container *ngIf="data?.children?.length;">
            <ng-container *ngFor="let child of data?.children; last as isLastChildZone; index as childZoneIndex;"
              [ngTemplateOutlet]="zoneNode"
              [ngTemplateOutletContext]="{ $implicit: child, isLast: isLastChildZone, index: childZoneIndex, depth: data?.depth + 1, parentContent: generalService?.removePropertyFromObject(data, 'children'), isSuperFirst: false  }">
            </ng-container>
          </ng-container>
        </ul>
      </ng-container>
    </li>
  </ng-template>
</div>